module.exports = __webpack_public_path__ + "media/images/shared/spinner-30c6228fad5177c0124907e5456b3009.svg";